module.exports = __webpack_public_path__ + "3b81ca57da058a9d375d19f84101a1a6.svg";